import { render, staticRenderFns } from "./TempHumiIndexCard.vue?vue&type=template&id=4f9d8870"
import script from "./TempHumiIndexCard.vue?vue&type=script&lang=js"
export * from "./TempHumiIndexCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports